import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCreditPurchaseStore = defineStore('credit-purchase', () => {
  const open = ref(false);
  const productId = ref<string | null>(null);
  const resume = ref<(() => void | Promise<void>) | null>(null);
  function show(input?: {
    productId?: string;
    resume?: () => void | Promise<void>;
  }): void {
    productId.value = input?.productId ?? null;
    resume.value = input?.resume ?? null;
    open.value = true;
  }
  function close(): void {
    open.value = false;
    productId.value = null;
    resume.value = null;
  }
  async function complete(): Promise<void> {
    const action = resume.value;
    close();
    await action?.();
  }
  return { open, productId, show, close, complete };
});
